import { LOCALES } from './constants';

export const localeCodes = LOCALES.map((l) => l.code);

export function dirFor(locale: string): 'ltr' | 'rtl' {
	return LOCALES.find((l) => l.code === locale)?.dir ?? 'ltr';
}
